setTimeout(function(){
  jQuery(".currency-picker").niceSelect();

  jQuery(".collectionReadmore").click(function(e){
    e.preventDefault();
    $(".ch-content-des").slideToggle("slow");
    $(this).find("span").toggle();
  });
//   jQuery(".search-button").click(function(e){
//     e.preventDefault();
//     jQuery("#Search").slideToggle("slow");
//   });
  jQuery(".hasSub").click(function(e){
    e.preventDefault();
    if(jQuery(window).width() < 768) {
      jQuery(this).next().click();
    }
  });
},1000);